import * as angular from "angular";
import {IController} from "angular";

export class taskRelationTypeSelectCtrl implements IController {

  relationType: any;
  ngRequired: boolean;
  ngPlaceholder: string;
  options: any;
  onChange: Function;

  private relationTypes: any;

  /* @ngInject */
  constructor(private tasksConstants) {
  }

  $onInit() {
    this.relationTypes = this.tasksConstants.relationTypes;
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskRelationTypeSelect', {
    bindings: {
      relationType: '<',
      ngRequired: '@?',
      ngPlaceholder: '@?',
      options: '<?',
      onChange: '&'
    },
    template: require('./task-relation-type-select.html').default,
    controller: taskRelationTypeSelectCtrl
  });
